import { FunctionComponent } from "react";

import { Icon, IconProps } from "./icon";

export const Twitter: FunctionComponent<IconProps> = ({ className }) => {
    return (
        <Icon className={className}>
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M12.6.8h2.5l-5.4,6.1,6.3,8.3h-4.9l-3.9-5.1-4.4,5.1H.3l5.7-6.6L0,.8h5.1l3.5,4.6L12.6.8ZM11.7,13.8h1.4L4.3,2.2h-1.5l8.9,11.6Z"
            />
        </Icon>
    );
};
